
import { Button } from "primereact/button";
export function MyScheduleCarousel(props: any) {
    function handleClickAgentSchedule() {
        props?.setDataFromChild(true);
    }
   

    return (
        <>
        
            
            <div
                className="card border-0 mb-0 pb-0 cursorPointer"
                onClick={handleClickAgentSchedule}
            >
                <img
                    src={props.web_url}
                    className="w-100 img-fluid desktopImage"
                    alt="My Schedule"
                    style={{ cursor: "pointer", zIndex: 1 }}
                />
                <img
                    src={props.mobile_url}
                    className="w-100 img-fluid mobileImage"
                    alt="My Schedule"
                    style={{ cursor: "pointer", zIndex: 1 }}
                />
                <div
                    className="card-img-overlay text-start"
                    style={{
                        zIndex: 2,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        pointerEvents: "none",
                    }}
                >
                    <div
                        className="row position-absolute bottom-0 start-0 mb-0 me-2 ms-2 mb-md-5 me-md-5 desktopTextWhite"
                        style={{
                            bottom: "20px",
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                       
                    </div>
                </div>
            </div>
        

        </>
    );
}
